"use client";
import { useEffect, useState } from "react";
import { tokenStorage } from "@/app/lib/api/tokenStorage";
import useAuth from "@/app/lib/features/auth/auth.hook";

/**
 * Kullanıcının giriş yapmış olma ihtimali — auth'a bağlı alanların "henüz
 * kesin değil" durumunu ayırt etmek için.
 *
 * Neden Redux'taki `isAuthenticated` yetmiyor: o bayrak ancak `getUserProfile()`
 * döndükten sonra true oluyor (AppEffects). Auth'a bağlı bir alanı ona göre
 * gizlemek yarış durumu yaratır — veri fetch'i profil fetch'inden önce dönerse
 * gate hiç devreye girmez, sonra dönerse "değer → placeholder → değer" olur.
 * Token cookie'si ise mount anında zaten mevcut ve API istekleri onu taşıyor.
 *
 * Neden effect içinde okunuyor: cookie SSR'da erişilemez. Render sırasında
 * okunursa sunucu HTML'i ile ilk client render'ı ayrışır (hidrasyon uyuşmazlığı).
 * Bu yüzden sunucu ve ilk client render daima `false` görür, değer mount'tan
 * sonra kesinleşir.
 */
const useHasAuthToken = (): boolean => {
  const { isAuthenticated } = useAuth();
  const [hasToken, setHasToken] = useState(false);

  useEffect(() => {
    setHasToken(!!tokenStorage.getAccessToken());
  }, [isAuthenticated]);

  return hasToken;
};

export default useHasAuthToken;
